import React, { useState, useEffect } from "react";
import config from "../../config.json";
import {Person} from "../../domain/Person";

interface Props {
    changeStepClick: (stepName: string) => void;
    greeter: Person;
    skipGuestBook: Boolean;
}

const GuestCardStep: React.FC<Props> = ({ changeStepClick, greeter, skipGuestBook }) => {
    const [name, setName] = useState("");
    const [title, setTitle] = useState("");
    const [work, setWork] = useState("");

    useEffect(() => {
        if (skipGuestBook) {
            changeStepClick("complete");
        }
    }, []);

    return (
        <>
                <h1>Udskriv gæstekort</h1>
                <div className='guest-form'>
                    <div className='group'>
                        <label>Navn:</label>
                        <input type='text' value={name} onChange={(e) => setName(e.target.value)} />
                    </div>

                    <div className='group'>
                        <label>Titel:</label>
                        <input type='text' value={title} onChange={(e) => setTitle(e.target.value)} />
                    </div>

                    <div className='group'>
                        <label>Virksomhed:</label>
                        <input type='text' value={work} onChange={(e) => setWork(e.target.value)} />
                    </div>
                    <div className='guest-card-buttons'>
                        <div className='button next-card' >Næste gæstekort</div>
                        <div className='button next-card' >Gruppe check ind</div>
                    </div>

                    <div className='submit-group'>
                        <div className='button green' onClick={() => changeStepClick("complete")}>
                            Afslut
                        </div>
                        <div
                            className='button pink'
                            onClick={() => {
                                let printWindow = window.open('', 'PRINT', '');
                                const printDiv = document.getElementById("print-id");
                                if(printWindow != null && printDiv != null){
                                    printWindow.document.write('<html><head><style>');
                                    printWindow.document.write("@import url('https://fonts.googleapis.com/css?family=Sanchez|Fira+Sans|Lato');" +
                                        "@media print{" +
                                        " @page \n" +
                                        "    {\n" +
                                        "        size: A4 landscape;   /* auto is the initial value */\n" +
                                        "        margin: 0mm;  /* this affects the margin in the printer settings */\n" +
                                        "    }" +
                                        "}");
                                    printWindow.document.write('</style></head><body>');
                                    printWindow.document.write(printDiv.innerHTML);
                                    printWindow.document.write('</body></html>');
                                    printWindow.document.close(); // necessary for IE >= 10
                                    printWindow.focus(); // necessary for IE >= 10*/

                                    printWindow.print();
                                    printWindow.close();
                                }
                                return true;
                            } }
                        >
                            Udskriv gæstekort
                        </div>
                    </div>
                </div>
                <div id='print-id' style={{position: "absolute", top: "0", right: "0", width: "842px", height: "595px", visibility: "hidden"}}>
                    <div className='print' style={{
                        position: "absolute",
                        top: "0",
                        left: "0",
                        background: "white",
                        width: "100%",
                        height: "100%",
                        color: "black",
                        padding: "25px",
                        boxSizing: "border-box",
                        fontFamily: "'Fira Sans', sans-serif"
                    }}>
                        <div className='top-left' style={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            margin: "25px",
                            fontSize: "100px",
                            color: "#39b14a"
                        }}>
                            Gæst
                        </div>
                        <div className='top-right' style={{
                            position: "absolute",
                            top: "0",
                            right: "0",
                            margin: "25px",
                            fontSize: "100px",
                            color: "#39b14a"
                        }}>
                            Logo
                        </div>
                        <div className='print-name' style={{
                            position: "absolute",
                            top: "250px",
                            fontSize: "60px",
                            fontWeight: "bold"
                        }}>
                            {name}
                        </div>
                        <div className='print-title' style={{
                            position: "absolute",
                            top: "325px",
                            fontSize: "60px"
                        }}>
                            {title}
                        </div>
                        <div className='print-work' style={{
                            position: "absolute",
                            top: "400px",
                            fontSize: "60px"
                        }}>
                            {work}
                        </div>
                    </div>
                </div>

                <div className='guest-card-message'>
                    <div className='msg'>
                        "Jeg er ligestraks fremme, blot udfyld dine informationer og tryk print."
                    </div>
                    <img src={`${config.server}${greeter.imagePath}`} alt='greeter' />
                </div>
            </>
    );
};

export default GuestCardStep;